import { AuctionLaneType } from 'store/shared/api/graph/interfaces/types';
import { EnumTranslationMap } from 'utils/formUtils';

export const auctionLaneTypeTranslationMap: EnumTranslationMap<typeof AuctionLaneType> = {
  DIGITAL: 'auction_lane_type_digital',
  PHYSICAL: 'auction_lane_type_physical',
};
